import { Nullable } from "src/js/types/Nullable";
import SITE_OVERVIEW from "react-migration/domains/sites/apollo/li-api/queries/siteOverview.gql";
import { SiteOverview } from "../typings/Site";
import { routedClient } from "react-migration/lib/persistence/apollo";
import { useQuery } from "@apollo/client";

interface SiteOverviewResponse {
  siteOverview: SiteOverview;
}

export async function getSiteById(_id: string, isShared = false): Promise<Nullable<SiteOverview>> {
  try {
    const response = await routedClient.query<SiteOverviewResponse>({
      query: SITE_OVERVIEW,
      variables: { _id, isShared },
    });

    return response.data?.siteOverview || null;
  } catch (e) {
    return null;
  }
}

export function useSiteById(
  siteId?: string | null,
  isShared = false
): {
  site: SiteOverview | undefined;
  loading: boolean;
} {
  const { data, ...rest } = useQuery<SiteOverviewResponse>(SITE_OVERVIEW, {
    variables: { _id: siteId, isShared },
    client: routedClient,
    skip: !siteId,
  });

  return { site: data?.siteOverview, ...rest };
}
